import gql from 'graphql-tag';

export default gql`
  fragment AllDetails on Order {
    id
    poID
    status
    statusLastUpdated
    createdOn
    createdAt
    origin
    requestedDeliveryDate
    creditStatus
    rejectStatus
    deliveryBlock
    orderType
    podRelevant
    indexTable
    etaDate
    soldTo {
      id
      salesOrg
      address {
        name
        street
        city
        postalCode
        region
        country
      }
    }
    shipTo {
      id
      salesOrg
      address {
        name
        street
        city
        postalCode
        region
        country
      }
      smhActiveUser
      vmiIndicator
    }
    division
    distributionChannel
    partnerInfo {
      imoNumber
      partnerNumber
      vesselName
    }
    items {
      index: id
      status
      backorderedQuantity
      desiredQuantity
      actualQuantity
      outstandingQuantity
      unitOfMeasure
      routeCode
      rejectedReasonDesc
      rejectedReasonCode
      product {
        id
        description
        group
        unitOfMeasure
      }
      plant {
        id
        description
      }
      deliveries {
        deliveryId: id
        distributorDeliveryNumber
        epodURL
        shippingCondition
        deliveryItemNumber
        createdOn
        provenOn
        goodsIssueDate
        quantity
        unitOfMeasure
        deliveryPriority
        trackingIdNumber
        status
        sourceApplication
        shipment {
          id
          bulk
          createdOn
        }
        carrier {
          id
          description
          email
        }
        invoice {
          id
          createdOn
          invoiceItemNumber
        }
        tmsOrKeplerDeliveryEvent {
          deliveryDate
          id
          eventTypeCode
          eventStatus
          eventTypeMessage
          timeToDelivery
          vehicleDistance
          vehicleDistanceUnit
        }
      }
      schedules {
        index: id
        orderedQuantity
        confirmedQuantity
        unitOfMeasure
        promiseDate
        firmDate
        roughDate
      }
    }
  }
`;
